import { useNavigate } from "react-router-dom";
import { Plus, ClipboardText, Receipt, CurrencyEur, CalendarBlank, UsersThree, Camera, Calculator, Truck, FileText, HardHat, ShoppingCart, Buildings } from "@phosphor-icons/react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";

export const AZIONI_NUOVO = {
  studio: [
    { label: "Incarico", to: "/pratiche?nuovo=1", icon: ClipboardText, hint: "pratica, DOCFA, CILA…" },
    { label: "Preventivo", to: "/preventivi?nuovo=1", icon: Receipt },
    { label: "Avviso di notula", to: "/fatturazione?nuovo=1", icon: CurrencyEur },
    { label: "Appuntamento", to: "/calendario?nuovo=1", icon: CalendarBlank, hint: "sopralluogo, incontro" },
    { label: "Cliente", to: "/clienti?nuovo=1", icon: UsersThree },
    { label: "Verbale rapido", to: "/verbale-rapido", icon: Camera, hint: "foto + dettatura" },
    { label: "Computo metrico", to: "/computi-metrici?nuovo=1", icon: Calculator },
  ],
  impresa: [
    { label: "Fattura fornitore", to: "/impresa/movimenti?cat=fattura_ricevuta&nuovo=1", icon: FileText },
    { label: "Bolla / DDT", to: "/impresa/movimenti?cat=ddt&nuovo=1", icon: Truck },
    { label: "Fattura emessa", to: "/impresa/movimenti?cat=fattura_emessa&tipo=entrata&nuovo=1", icon: CurrencyEur },
    { label: "Scontrino", to: "/impresa/movimenti?cat=scontrino&nuovo=1", icon: ShoppingCart, hint: "spesa in contanti" },
    { label: "Cantiere", to: "/impresa/cantieri?nuovo=1", icon: HardHat },
    { label: "Cliente / Fornitore", to: "/clienti?nuovo=1", icon: Buildings },
  ],
};

/** Tasto "+ Nuovo" unico: in alto nella barra e fluttuante da telefono. Chiede cosa creare e apre direttamente il form. */
export function NuovoGlobale({ ambito, variante = "barra" }) {
  const navigate = useNavigate();
  const azioni = AZIONI_NUOVO[ambito] || AZIONI_NUOVO.studio;
  const trigger = variante === "fab" ? (
    <button type="button" className="lg:hidden fixed bottom-20 right-4 z-40 h-12 w-12 rounded-full bg-slate-900 text-white shadow-xl flex items-center justify-center active:scale-95 transition-transform" aria-label="Nuovo" data-testid="nuovo-fab">
      <Plus size={22} weight="bold" />
    </button>
  ) : (
    <button type="button" className="h-9 inline-flex items-center gap-1.5 rounded-md bg-slate-900 text-white px-3 text-sm font-semibold hover:bg-slate-800 shrink-0" data-testid="nuovo-globale">
      <Plus size={16} weight="bold" /> <span className="hidden sm:inline">Nuovo</span>
    </button>
  );
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64" data-testid={`nuovo-menu-${variante}`}>
        <DropdownMenuLabel className="text-[10px] font-mono uppercase tracking-widest text-slate-400">Cosa vuoi creare?</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {azioni.map(({ label, to, icon: Icon, hint }) => (
          <DropdownMenuItem key={to} onSelect={() => navigate(to)} className="gap-2.5 py-2 cursor-pointer" data-testid={`nuovo-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <Icon size={16} className="text-slate-500" />
            <span className="flex-1">{label}</span>
            {hint && <span className="text-[10px] text-slate-400">{hint}</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
